<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabBasicMixin],
  data: function () {
    return {
      collectionsContent: null
    };
  },
  mounted() {
    this.loadCollections();
  },
  methods: {
    loadCollections() {
      if (this.content.parent_names && this.content.parent_names.length > 0) {
        Fandom.ajax({
          url: Fandom.applyContextToUrl('/api/v5/get_contents_by_names'),
          method: "POST",
          data: {
            contents_names: this.content.parent_names,
            content_filtering: [this.collectionTag],
            layout_extra_field_name: "$none",
            layout: "tile-related-collections"
          },
          success: (data) => {
            Fandom.getContentsCallback(data.main_content_name, data);
            Vue.set(this, "collectionsContent", data.name_to_content[data.main_content_name]);
          }
        })
      }
    }
  },
  computed: {
    collectionTag() {
      return get(globalState, ["pageModel", "layout", "content", "collection_tag"], "tag-collection");
    },
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 8);
      return [
        `col-lg-${columnWidth}`
      ];
    },
  }
};
</script>

<template>
  <div relate-collection-component v-if="collectionsContent && collectionsContent.children && collectionsContent.children.length && collectionsContent.children.length > 0" class="py-5">
    <div class="container mt-4">
      <div class="row justify-content-center">
        <div :class="columnClasses" class="d-flex justify-content-center align-items-center text-center">
          <h3 class="font-weight-light mb-0">{{ft("globals.content_in_these_collections")}}</h3>
        </div>
      </div>
    </div>
    <grid-isotope
      v-if="isContentVisibleToUser() && collectionsContent" 
      class="position-relative"
      tile-size="ultrawidecontent"
      :content="collectionsContent"
      :opt-container-content="containerContent"
      related-collections-component
    ></grid-isotope>
  </div>
</template>

<style lang="scss" scoped>

[relate-collection-component] {
  background-color: $gray-225;
}

</style>